import { authHeader } from './auth';

export default {
    data() {
        return {
            cmsData: []
        }
    },
    methods: {
        getCmsData: async function (url) {
            try {
                let config = {
                    method: "GET",
                    url: url,
                    headers: authHeader()
                }
                let response = await this.$axios(config);
                return response.data;
            } catch (error) {
                this.$swal.fire({
                    icon: "error",
                    text: error.response.data.message
                });
            }
        },
        createUpdateCMS: async function (url, data) {
            try {
                let response = await this.$axios({
                    method: 'POST',
                    url: url,
                    data: data,
                    headers: authHeader()
                });
                return response.data;
            } catch (error) {
                this.$swal.fire({
                    icon: "error",
                    text: error.response.data.message
                });
            }
        },
        getDataList: async function (url) {
            try {
                let config = {
                    method: "GET",
                    url: url,
                    headers: authHeader()
                }
                let response = await this.$axios(config);
                return response.data.data;
            } catch (error) {
                this.$swal.fire({
                    icon: "error",
                    text: error.response.data.message
                });
            }
        },
        postData: async function (config) {
            try {
                let response = await this.$axios(config);
                return response.data;
            } catch (error) {
                this.$swal.fire({
                    icon: "error",
                    text: error.response.data.message
                });
            }
        },
        updateData: async function (config) {
            try {
                let response = await this.$axios(config);
                return response.data;
            } catch (error) {
                this.$swal.fire({
                    icon: "error",
                    text: error.response.data.message
                });
            }
        },
        deleteData: async function (config) {
            await this.$axios(config).then((response) => {
                if (response.data.statusCode == 200) {
                    this.$swal.fire({
                        toast: true,
                        position: 'top-end',
                        text: response.data.message,
                        icon: "success",
                        showConfirmButton: false,
                        timer: 3000,
                        animation: false,
                        timerProgressBar: true,
                        didOpen: (toast) => {
                            toast.addEventListener('mouseenter', this.$swal.stopTimer)
                            toast.addEventListener('mouseleave', this.$swal.resumeTimer)
                        }
                    });
                }
            }).catch(error => {
                this.$swal.fire({
                    icon: "error",
                    text: error.response.data.message
                });
            });
        },
        getSingleData: async function (url) {
            try {
                let config = {
                    method: "GET",
                    url: url,
                    headers: authHeader()
                }
                let response = await this.$axios(config);
                return response.data;
            } catch (error) {
                this.$swal.fire({
                    icon: "error",
                    text: error.response.data.message
                });
            }
        }
    }
}